export default "__VITE_ASSET__jNrmutPf__"